export default function isIgnoredLoading(bool) {
  return {
    headers: {
      isIgnoredLoading: bool,
    },
  };
}
